import React, {useEffect, useState} from 'react';
import LogoLarge from '../Icons/LogoLarge';
import { getCurrentUser } from '../auth';
import { useTranslation } from "react-i18next";
import {Link} from "react-router-dom";
import LoadinPage from "../Components/LoadingPage";
import {IconArrowLeft} from "@tabler/icons-react";


const Home = () => {
    const { t } = useTranslation();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            setUser(getCurrentUser());
            setLoading(false);
        };
        fetchUser();
    }, []);

    if (loading) return (
        <div className="p-4 flex flex-col h-full relative">
            <div className="grow overflow-y-auto overflow-x-hidden">
                <LoadinPage />
            </div>
        </div>
    );

    return (
        <div className="p-4 flex flex-col gap-16">
            <div className="flex items-center justify-center">
                <LogoLarge className="w-full max-w-[20rem]" />
            </div>
            <div>
                {(!user) ? (
                    <div className="flex flex-col gap-4 mx-auto max-w-[48rem] w-full">
                        <div className="text-6xl font-bold">{t("home.intro.hi")},</div>
                        <div className="text-xl font-medium">{t("home.intro.youAreNotLoggedIn")}</div>
                        <div className="text-sm">{t("home.intro.itsNotNecessaryToRegister")}</div>
                        <div className="px-2 flex gap-2 mx-auto mt-10">
                            <Link to="/login" className="button-primary">{t('settings.user.login')}</Link>
                            <Link to="/registration" className="button-secondary">{t('settings.user.register')}</Link>
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col">
                        HERE WOULD BE SOME SIMPLE OVERVIEW
                    </div>
                )}
            </div>
        </div>
    );
};

export default Home;